
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/why-join-apcia",
      function () {
        return require("private-next-pages/about/why-join-apcia.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/why-join-apcia"])
      });
    }
  